import React from 'react';
import PropTypes from 'prop-types';

const mounths = {
  0: 'Enero',
  1: 'Febrero',
  2: 'Marzo',
  3: 'Abril',
  4: 'Mayo',
  5: 'Junio',
  6: 'Julio',
  7: 'Agosto',
  8: 'Septiembre',
  9: 'Octubre',
  10: 'Noviembre',
  11: 'Diciembre'
};
const monthsEn = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

/**
 * Format a date based on a locale
 * @property {string} date - a string representing a valid date
 * @property {string} locale - a string representing the current language
 * @returns {JSX}
 */
const FormatedDate = ({ date, locale }) => {
  const dateObj = new Date(date);
  switch (locale) {
    case 'en':
      return `${
        monthsEn[dateObj.getMonth()]
      } ${dateObj.getDate()} ${dateObj.getFullYear()}`;
    case 'es':
      return `${dateObj.getDate()} de ${mounths[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
    default:
      return `${dateObj.toDateString()}`;
  }
};

FormatedDate.propTypes = {
  date: PropTypes.string,
  locale: PropTypes.string,
};

export default FormatedDate;
